export const EventConstants = {
    IDENTIFIER_FIRST: 'first',
    IDENTIFIER_SECOND: 'second',
    TYPE_ACCEPT: 'acceptEvent',
    TYPE_CANCEL: 'cancelEvent'
}
